import PropTypes from 'prop-types';

import LeaderboardItem, { leaderboardItemShape } from './LeaderboardItem';

const LeaderboardsList = ({ leaderboards }) => (
  <>
    <h2 className="font-bold text-xl tracking-wider text-[#808080] mb-4">Top Active Users</h2>
    <ul className="grid gap-4">
      <li className="flex items-center justify-between">
        <p>Username</p>
        <p>Score</p>
      </li>
      {leaderboards.map((leaderboard) => (
        <LeaderboardItem {...leaderboard} key={leaderboard.user.id} />
      ))}
    </ul>
  </>
);

LeaderboardsList.propTypes = {
  leaderboards: PropTypes.arrayOf(PropTypes.shape(leaderboardItemShape)).isRequired,
};
export default LeaderboardsList;
